import { Directive, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { CategorySearch, ProductSearch } from '@hdms/shared/common-types';
import { ExtendedAutoSuggestions, SearchSuggestionService } from '@hdms/shared/page-frame/data-access';

@Directive()
export abstract class SearchResultsComponentAbstract {
  protected readonly suggestionService = inject(SearchSuggestionService);

  trackById(_index: number, item: CategorySearch | ProductSearch): string {
    return item.id;
  }

  protected getSuggestions$(): Observable<ExtendedAutoSuggestions> {
    return this.suggestionService.suggestions$;
  }
}
